export default __webpack_public_path__ + "static/media/testing.6a564ba6.webp";